import { DefaultButton, Stack } from '@fluentui/react';

import { editIcon, refreshIcon } from '../../../../../utils/icons';
import { actions as accountActions } from '../../../../Accounts/slice';
import { actions, useFormSelector } from '../../../slice';
import { getFormState } from '../../../slice/newFormReducers';
import ChangeAccountSection from './ChangeSection';
import AccountInfoSection from './InfoSection';
import Modal from './Modal';

export default () => {
  const activeAccount = useFormSelector((state) => state.activeAccount);

  if (activeAccount?.id) {
    return (
      <Stack tokens={{ childrenGap: 10 }}>
        <AccountInfoSection
          accountId={activeAccount.id}
          accountVersionId={activeAccount.versionId}
        />
        <Stack horizontal tokens={{ childrenGap: 10 }}>
          {activeAccount.id !== "mYYfPAtxPDZjUigTaQsg" && (
            <DefaultButton
              text={"Müşteri Bilgilerini Düzenle"}
              iconProps={editIcon}
              onClick={editActiveAccount}
            />
          )}
          <DefaultButton
            text={"Hesap Değiştir"}
            iconProps={refreshIcon}
            onClick={removeActiveAccount}
          />
        </Stack>
        <Modal />
      </Stack>
    );
  } else {
    return (
      <>
        <ChangeAccountSection activeAccountId={activeAccount?.id} />
        <Modal />
      </>
    );
  }
};

const removeActiveAccount = () =>
  actions.setFormVariable(["activeAccount", undefined]);
const editActiveAccount = () => {
  const formState = getFormState();

  actions.setFormVariable(["isAccountModalOpen", true]);
  accountActions.setActiveAccountId(formState.activeAccount!.id);
};
